import { Box, Button, Divider, Stack } from '@mui/material'
import { useRouter } from 'next/navigation'
import { FC, Fragment } from 'react'
import { Trans } from 'react-i18next'
import { useSetRecoilState } from 'recoil'
import {
  playListVideoActionUiTypeState,
  targetActionPlayListVideoInfoState,
} from '~/features/play_list/store'
import { VideoListItem } from '~/features/video/components/VideoListItem'
import { useVideoRecommends } from '~/features/video_detail/hooks/useVideoRecommends'

const VideoDetailRecommendsTab: FC<{ id: string }> = ({ id }) => {
  const videoRecommends = useVideoRecommends(id)
  const router = useRouter()
  const setPlayListVideoInfo = useSetRecoilState(targetActionPlayListVideoInfoState)
  const setUiType = useSetRecoilState(playListVideoActionUiTypeState)

  const onClickPlayListAction = (videoId: number) => {
    setPlayListVideoInfo({ videoId })
    setUiType('select')
  }

  return (
    <Stack spacing={2}>
      {videoRecommends.data?.videoRecommends?.edges?.map((edge, idx) => (
        <Fragment key={idx}>
          <Box paddingX={2}>
            <VideoListItem
              // FIXME: GraphQLのVideoも渡せるようにする
              video={{
                id: parseInt(edge.node!.id),
                title: edge.node!.title ?? undefined,
                description: edge.node!.description ?? undefined,
                duration_min: edge.node!.duration?.minutes ?? undefined,
                duration_second: edge.node!.duration?.seconds ?? undefined,
                portrait_thumbnail_url: edge.node!.portraitThumbnail ?? undefined,
                landscape_thumbnail_url: edge.node!.landscapeThumbnail ?? undefined,
                creator: {
                  id: parseInt(edge.node!.creator!.id),
                  name: edge.node!.creator!.name ?? '',
                  avatar_url: edge.node!.creator!.avatar ?? undefined,
                },
                playlists: [],
                rowOrder: idx,
                created_at: new Date().toDateString(),
              }}
              onClickVideoItem={() => router.push(`/videos/${edge.node!.id}/play`)}
              onClickPlayListAction={() => onClickPlayListAction(parseInt(edge.node!.id))}
            />
          </Box>
          <Divider />
        </Fragment>
      ))}
      {videoRecommends.hasNextPage && (
        <Button onClick={videoRecommends.loadMore} sx={{ borderRadius: 'inherit' }}>
          <Trans i18nKey='view_more' />
        </Button>
      )}
    </Stack>
  )
}

export default VideoDetailRecommendsTab
